import { StorageMap } from '@ngx-pwa/local-storage';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';
import { LoginService } from 'src/app/modules/distributor/services/login.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  public loginData: any;
  
  public passwordForm: FormGroup;
  public buttonLoader: any = false;

  constructor(
    private _utilService: UtilService,
    private _loginService: LoginService
  ) {}

  ngOnInit(): void {
    // Set password form
    this.passwordForm = new FormGroup({
      current_password: new FormControl(null, [Validators.required, Validators.minLength(4), Validators.maxLength(20)]),
      new_password1: new FormControl(null, [Validators.required, Validators.minLength(4), Validators.maxLength(20)]),
      new_password2: new FormControl(null, [Validators.required, Validators.minLength(4), Validators.maxLength(20)])
    });

    this.buttonLoader = false;

    this.getStorageData();
  }

  async getStorageData() {
    this.loginData = await this._utilService.getStorageData('D_LOGIN');
  }

  // Change password submit
  async onChangePassword() {
    if (!this.passwordForm.value.current_password) {
      this._utilService.showToast('Please enter current password', '', 'warning', {});
    } else if (this.passwordForm.controls.current_password.status == 'INVALID') {
      this._utilService.showToast('Current password entered is invalid', '', 'warning', {});
    } else if (!this.passwordForm.value.new_password1) {
      this._utilService.showToast('Please enter new password', '', 'warning', {});
    } else if (this.passwordForm.controls.new_password1.status == 'INVALID') {
      this._utilService.showToast('New password entered is invalid', '', 'warning', {});
    } else if (!this.passwordForm.value.new_password2) {
      this._utilService.showToast('Please confirm new password', '', 'warning', {});
    } else if (this.passwordForm.value.new_password1 != this.passwordForm.value.new_password2) {
      this._utilService.showToast('New password is not matching', '', 'warning', {});
    } else {
      let changeUserPasswordBody = {
        user_id: this.loginData.user_details.user_id,
        current_password: this.passwordForm.value.current_password,
        new_password: this.passwordForm.value.new_password1
      };

      this.buttonLoader = true;

      // Check username & password
      this._loginService.changeUserPassword(this.loginData.token, changeUserPasswordBody).subscribe(async changeUserPasswordResponse => {
        this.buttonLoader = false;

        if (changeUserPasswordResponse.status === true) { // Success
          this._utilService.showToast('Password changed successfully', '', 'success', {});
        } else {
          this._utilService.showToast(changeUserPasswordResponse.message, '', 'error', {});
        }
      }, error1 => { // Error from changeUserPassword
        this.buttonLoader = false;
      });
    }
  }

}
